var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"containerC"}},[_c('v-app',[_c('v-skeleton-loader',{staticClass:"item",attrs:{"loading":_vm.loading,"type":"card","max-width":400,"max-height":300}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }